<template>
 <router-view class="rtl" />
</template>

<script setup>
import { useUserInfoStore } from '@/store/userInfo';
import {  onMounted } from "vue";
import { useAuthStore } from "@/store/useAuth";

const userInfoStore=useUserInfoStore();
userInfoStore.callUserInfo();

const authStore = useAuthStore();

onMounted(() => {
    authStore.initializeStore();
});

</script>

<style>

</style>
